export enum GlobalActionsEnum {
  RESET_STORE = 'RESET_STORE',
}

interface ResetStore {
  type: GlobalActionsEnum.RESET_STORE;
}

export type GlobalActions = ResetStore;
